import { LayoutModule } from '../../../../layout/modules';
import PersonIcon from '@mui/icons-material/Person';
import { CasesGeneralInformationRegisterHistory } from './registerHistory';
import { useCasesGeneralInformationDetail } from './hook';
import { CasesGeneralInformationDetailActions } from './actions';
import { CasesGeneralInformationAccountInfo } from './accountInfo';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import {
    isOnlyViewProfile,
    isSupervisor,
} from '../../../../../shared/types/profiles';
import { CaseDetailGeneralInfo } from './generalInfo';

export const CasesGeneralInformationDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const { casesGeneralInformation, loading } =
        useCasesGeneralInformationDetail();

    const additionalButtons =
        !isSupervisor(type) && !isOnlyViewProfile(type) ? (
            <CasesGeneralInformationDetailActions
                casesGeneralInformationId={casesGeneralInformation?.id || ''}
            />
        ) : undefined;

    return (
        <>
            <LayoutModule
                title="Detalle caso información general"
                titleChildren="Detalle cuenta"
                icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                additionalButtons={additionalButtons}
            >
                <CasesGeneralInformationAccountInfo
                    account={casesGeneralInformation?.account}
                    loading={loading}
                />
            </LayoutModule>
            <CaseDetailGeneralInfo
                casesGeneralInformation={casesGeneralInformation}
                account={casesGeneralInformation?.account}
            />
            <CasesGeneralInformationRegisterHistory
                casesGeneralInformation={casesGeneralInformation}
            />
        </>
    );
};
